import {lazy} from "react";

export const ReportCarWashGeoZoneVisitsLazy = lazy(()=>import('./ReportCarWashGeoZoneVisits'))